import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitConsultation = (payload) =>
  api.post("/consultations", payload).then((r) => r.data);

export const sendGenieMessage = (session_id, message) =>
  api.post("/genie/chat", { session_id, message }).then((r) => r.data);

export const fetchGenieHistory = (session_id) =>
  api.get(`/genie/history/${session_id}`).then((r) => r.data);

export const fetchLocations = () => api.get("/locations").then((r) => r.data);
export const fetchLocation = (slug) =>
  api.get(`/locations/${slug}`).then((r) => r.data);

export const subscribeNewsletter = (email) =>
  api.post("/newsletter", { email }).then((r) => r.data);
